<app-account-selection [thankyoumessage]="message"
[header]="headerTitle"></app-account-selection>
